import React, { Component } from 'react';
import Main, {
    getWalletBalance,
    getWalletUserSessionDetails,
    logoutWalletUser,
    login
} from '@practicalcodelabs/moneyblox-dev';
import * as actions from "../../actions";
import { connect } from "react-redux";

export const getMoneyBloxWalletBalance = (props, isSilentLogin) => {
    getWalletBalance()
        .then((payload) => {
            if (payload.hasOwnProperty("wallet_balance")) {
                props.setWalletBalance(payload.wallet_balance)
            }
        })
        .catch((error) => {
            props.setWalletBalance("0.00")
            // if (!isSilentLogin) {
            //     //if not silent login then show the modal
            //     props.showMoneyBloxModal()
            // }
        })
}
export const getMoneyBloxWalletUserSessionDetails = (props) => {
    getWalletUserSessionDetails()
        .then((payload) => {
            if (payload.hasOwnProperty("data")) {
                props.setWalletUserSessionDetails(payload.data)
            }
        })
        .catch((error) => {
            props.setWalletUserSessionDetails(null)
        })
}

export const doMoneyBloxLogin = (payload, props) => {
    //let ref = this;
    login(
        payload.login,
        payload.password,
        {
            'platform': payload.device.platform,
            'name': payload.device.name,
            'version': payload.device.version,
            'ip': payload.device.ip,
            'id': payload.device.id,
            'sdk_version': '0.1'
        }, (issuccess, response) => {
            // on successful login get users current balence : VUEPAY-29
            getWalletBalance()
                .then((payload) => {
                    if (payload.hasOwnProperty("wallet_balance")) {
                        props.setWalletBalance(payload.wallet_balance);
                    }

                    this.getMoneyBloxWalletUserSessionDetails(props);
                })
                .catch((error) => {
                    //props.setWalletBalance("0.00")
                    // if (!isSilentLogin) {
                    //     //if not silent login then show the modal
                    //     props.showMoneyBloxModal()
                    // }
                })


        })
}

export const getMoneyBloxCurrentWalletBalance = (callback) => {
    getWalletBalance()
        .then((payload) => {
            if (payload.hasOwnProperty("wallet_balance")) {
                callback(payload.wallet_balance)

            }
        })
        .catch((error) => {
            callback("0.00")
        })
}

export const logoutMoneyBloxWalletUser = () => {
    logoutWalletUser()
        .then((payload) => {

        })
        .catch((error) => {

        })
}


class MoneyBlox extends Component {

    constructor(props) {
        super(props)

        this.state = {
            active: false
        }
    }

    componentDidMount() {
        getMoneyBloxWalletBalance(this.props, false);
        getMoneyBloxWalletUserSessionDetails(this.props);
    }

    _closeModalListener = () => {
        getMoneyBloxWalletBalance(this.props, true);
        getMoneyBloxWalletUserSessionDetails(this.props);
        this.props.hideMoneyBloxModal();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance) {
            //.log(nextProps.moneyblox.wallet_balance);
        }

        if (this.props.moneyblox.user_details !== nextProps.moneyblox.user_details) {
            ////console.log(nextProps.moneyblox.user_details);
        }

        if (this.props.moneyblox.isVisible !== nextProps.moneyblox.isVisible) {
            this.setState({
                active: nextProps.moneyblox.isVisible
            })
        }
    }
    render() {

        return (
            <div>
                {
                    this.state.active &&
                    <Main isActive={this.state.active} closeModalListener={this._closeModalListener} />}
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {

    return {
        moneyblox: state.moneyblox
    };
}

export default connect(mapStateToProps, actions)(MoneyBlox);
